import { PUBLIC_URL } from "config/consts";

// Bỏ PUBLIC_URL (vd. "/iot-cloud") ở đầu đường dẫn: router đã có basename, giữ lại thì thành "/iot-cloud/iot-cloud/...".
// Trả undefined nếu không phải đường dẫn trong app (để nơi gọi dùng trang mặc định).
export function toRouterPath(path: unknown, publicUrl: string = PUBLIC_URL || ""): string | undefined {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return undefined;
  const hasPrefix =
    publicUrl && (path === publicUrl || path.startsWith(publicUrl + "/") || path.startsWith(publicUrl + "?"));
  const result = hasPrefix ? path.slice(publicUrl.length) : path;
  return result === "" || result.startsWith("?") ? undefined : result;
}
